import { render, staticRenderFns } from "./PeopleAndRolesRow.vue?vue&type=template&id=4bef021e&scoped=true&"
import script from "./PeopleAndRolesRow.vue?vue&type=script&lang=js&"
export * from "./PeopleAndRolesRow.vue?vue&type=script&lang=js&"
import style0 from "./PeopleAndRolesRow.vue?vue&type=style&index=0&id=4bef021e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bef021e",
  null
  
)

export default component.exports